import React from "react";
import { Errors, Ul, Li } from "./styles";

const Error = ({ error, close, setClose }) => {
  return (
    <>
      {error !== null && (
        <Errors className={close && "hide"}>
          <h2
            onClick={() => setClose(true)}
            style={{
              color: "red",
              float: "right",
              paddingRight: "1em",
              cursor: "pointer",
            }}
          >
            &times;
          </h2>
          <h1>Lists of errors</h1>
          <Ul>
            <Li>
              {error.first_name !== undefined && (
                <span className='error'>{error.first_name}</span>
              )}
            </Li>
            <Li>
              {error.last_name !== undefined && (
                <span className='error'>{error.last_name}</span>
              )}
            </Li>
            <Li>
              {error.stage_name !== undefined && (
                <span className='error'>{error.stage_name}</span>
              )}
            </Li>
            <Li>
              {error.email !== undefined && (
                <span className='error'>{error.email}</span>
              )}
            </Li>
            <Li>
              {error.phone_number !== undefined && (
                <span className='error'>{error.phone_number}</span>
              )}
            </Li>
            <Li>
              {error.biography !== undefined && (
                <span className='error'>{error.biography}</span>
              )}
            </Li>
            <Li>
              {error.gender !== undefined && (
                <span className='error'>{error.sex}</span>
              )}
            </Li>
            <Li>
              {error.password !== undefined && (
                <span className='error'>{error.password}</span>
              )}
            </Li>
            <Li>
              {error.confirm_password !== undefined && (
                <span className='error'>{error.confirm_password}</span>
              )}
            </Li>
            <Li>
              {error.date_of_birth !== undefined && (
                <span className='error'>{error.date_of_birth}</span>
              )}
            </Li>
            <Li>
              {error.profile_pic !== undefined && (
                <span className='error'>{error.profile_pic}</span>
              )}
            </Li>
            <Li>
              {error.state !== undefined && (
                <span className='error'>{error.state}</span>
              )}
            </Li>
            <Li>
              {error.country !== undefined && (
                <span className='error'>{error.country}</span>
              )}
            </Li>
          </Ul>
        </Errors>
      )}
    </>
  );
};

export default Error;
